import React, { useState } from "react";

import Button from "../../../Button";
import { getImgUrl } from "../../../../utills";
import useText from "../../../../hooks/useText";
import ImageRenderr from "../../../ImageRenderr/Index";
import RenderIfAvailable from "../../../RenderIfAvailable";
import HelpWidgetsFormModal from "../HelpWidgetsFormModal";
import { WHATSAPP_BTN_ID, CALL_BACK_BTN_ID } from "../../constant";
import { CALL_BACK_TEXT, SUCCESS } from "../../../../GlobalConstant";
import { CALL_BACK_WHITE_IMAGE, WHATS_APP_IMAGE, CLOSE_ICN } from "../../../../GlobalConstant/image";

import styles from "../../HelpFloatWidget.module.scss";

const HelpWidgetsModal = ({ configData = {}, handleClose }) => {

  const [modalName, setModalName] = useState(null);
  const { translations, whatsAppConfig, isWhatsAppEnable, isCallBackEnable } = configData
  const { getText } = useText();

  const handleToggleWidgetsFormModal = (id = null) => {
    setModalName(id)
  }
  const handleModalClose = () => {
    handleClose()
  }
  const handleWhatsappRedirection = () => {
    window.open(whatsAppConfig?.redirectionUrl, '_blank')
  }

  return <>
    <div className={styles["help-widget"]}>
      <div className={styles["header-wrapper"]}>
        <div className={styles["help-title"]}><span>{getText(translations?.NEED_SOME_HELP_TEXT)}</span> <span>{getText(translations?.WE_ARE_HERE_ASSIST_YOU_TEXT)}</span></div>
        <ImageRenderr height="14px" width="14px" src={getImgUrl(CLOSE_ICN)} onIcnClick={handleModalClose} />
      </div>
      <div className={styles["help-actions"]}>
        <RenderIfAvailable value={isWhatsAppEnable}>
          <Button id={WHATSAPP_BTN_ID} text={getText(translations?.WHATSAPP_TEXT)} callBack={handleWhatsappRedirection} icnUrl={getImgUrl(WHATS_APP_IMAGE)} btnType={SUCCESS} />
        </RenderIfAvailable>
        <RenderIfAvailable value={isCallBackEnable}>
          <Button id={CALL_BACK_BTN_ID} text={getText(CALL_BACK_TEXT)} callBack={handleToggleWidgetsFormModal} icnUrl={getImgUrl(CALL_BACK_WHITE_IMAGE)} />
        </RenderIfAvailable>
      </div>
    </div>
    <RenderIfAvailable value={modalName}>
      <HelpWidgetsFormModal onClose={handleToggleWidgetsFormModal} configData={configData} type={modalName} />
    </RenderIfAvailable>
  </>
}

export default HelpWidgetsModal